//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Issue.js";
import "../no/NXObject.js";
let d=[[[0,"AttachmentType",1,0],[0,"ReferencedAttachmentId",1,0]],[[["bookmarkFileSpec","imageFileSpec"],"RecaptureSnapshot",{},2,0]],[]];
SPLM.Issue.IssueAttachment = class extends SPLM.NXObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Issue.IssueAttachment";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Issue.IssueAttachment.Type = Object.freeze({
    "Generic" : "Generic", "Text" : "Text", "Part" : "Part", "Xml" : "Xml", "Image" : "Image", "ValidationLog" : "ValidationLog", "Bookmark" : "Bookmark", "Snapshot" : "Snapshot", "ValidationResult" : "ValidationResult", "Workset" : "Workset", "ShapeDesignElement" : "ShapeDesignElement", "ReuseDesignElement" : "ReuseDesignElement", "SubordinateDesignElement" : "SubordinateDesignElement", "PromissoryDesignElement" : "PromissoryDesignElement", "DesignControlElement" : "DesignControlElement", "Subset" : "Subset", "MSWord" : "MSWord", "MSExcel" : "MSExcel", "MSPowerPoint" : "MSPowerPoint", "VisualizationSession" : "VisualizationSession"});

export default SPLM;